import { z } from "zod";

export const ManagerLevelSchema = z.object({
  level: z.enum(['account', 'project', 'activity', 'procedure']).nullable(),
});

export type ManagerLevel = z.infer<typeof ManagerLevelSchema>;